import type React from 'react'

interface HighlightTextProps {
  text?: string
  highlight?: string
}

export const HighlightText: React.FC<HighlightTextProps> = ({ text, highlight }) => {
  if (!text) return null
  if (!highlight) return <>{text}</>
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'))

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <span key={index} className="bg-yellow-200">
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  )
}
